var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cursor",class:_vm.theme},[_c('div',{staticClass:"circle-cursor circle-cursor--inner"}),_c('div',{staticClass:"circle-cursor circle-cursor--outer"})])}
var staticRenderFns = []

export { render, staticRenderFns }